import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Sidebar from "../../../../partials/aside/Sidebar";
import typeCollaboration from "./type-collaboration";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import validationAddMarketer from "../../../../../validtions/forms/user/marketer/add-marketer";
import { Link } from "react-router-dom";

export default function AddMarketer() {
  const history = useHistory();
  const [message, setMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [permanentPercent, setPermanentPercent] = useState(0);
  const [countPermanentPercent, setCountPermanentPercent] = useState(0);
  const [typeCollaborationUser, setTypeCollaborationUser] = useState(
    typeCollaboration.typeCollaborationConstant.WITHOUT_PERMANENT_PERCENT
  );

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (
      typeCollaborationUser ==
      typeCollaboration.typeCollaborationConstant.WITHOUT_PERMANENT_PERCENT
    ) {
      setPermanentPercent(0);
      setCountPermanentPercent(0);
      return;
    }
    if (
      typeCollaborationUser ==
      typeCollaboration.typeCollaborationConstant
        .WITH_UNLIMITED_PERMANENT_PERCENT
    ) {
      setCountPermanentPercent(0);
      return;
    }
  }, [typeCollaborationUser]);

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".content-wrapper");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationAddMarketer =
      validationAddMarketer.validateFormInfoUser(dataForm);
    if (resultValidationAddMarketer != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationAddMarketer,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddUserMarketer = await sendRequestAddUserMarketer(
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddUserMarketer) {
      return;
    }
    history.push("/user/marketer/all");
  };

  const sendRequestAddUserMarketer = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/manage",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }
    return true;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getDataForm = () => {
    return {
      first_name: document.querySelector("#first-name").value.trim(),
      last_name: document.querySelector("#last-name").value.trim(),
      email: document.querySelector("#email").value.trim(),
      password: document.querySelector("#password").value.trim(),
      mobile: document.querySelector("#mobile").value.trim(),
      identity_marketer: document
        .querySelector("#identity-marketer")
        .value.trim(),
      first_percent: document.querySelector("#first-percent").value.trim(),
      type_collaboration: typeCollaborationUser + "",
      permanent_percent: permanentPercent + "",
      count_permanent_percent: countPermanentPercent + "",
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">اضافه کردن بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/user/marketer/all" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="d-flex flex-column flex-lg-row">
                  <div className="flex-1 form-group px-lg-2">
                    <label>ایمیل</label>
                    <span className="text-danger">*</span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="ایمیل"
                      required
                    />
                  </div>

                  <div
                    dir="ltr"
                    className="flex-1 form-group px-lg-2 px-lg-2 d-flex align-items-end flex-column"
                  >
                    <label>
                      <span className="text-danger">*</span>
                      رمز عبور
                    </label>
                    <div dir="rtl" className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        min="8"
                        required
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-secondary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowPassword((prevState) => !prevState);
                          }}
                        >
                          <i
                            className={
                              showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column flex-lg-row">
                  <div className="flex-1 form-group px-lg-2">
                    <label>شماره موبایل</label>
                    <span className="text-danger">*</span>
                    <input
                      type="number"
                      className="form-control"
                      id="mobile"
                      placeholder="09121234567"
                      onWheel={(event) => event.currentTarget.blur()}
                      required
                    />
                  </div>
                  <div className="flex-1 form-group px-lg-2 px-lg-2">
                    <label>شناسه بازاریابی</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      id="identity-marketer"
                      required
                    />
                  </div>
                </div>

                <div className="d-flex flex-column flex-lg-row">
                  <div className="flex-1 form-group px-lg-2">
                    <label>نام</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      id="first-name"
                      required
                    />
                  </div>
                  <div className="flex-1 form-group px-lg-2 px-lg-2">
                    <label>نام خانوادگی</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      id="last-name"
                      required
                    />
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center py-2">
                  <label className="pl-2">درصد اولیه</label>
                  <input
                    style={{ width: "80px" }}
                    max="100"
                    min="1"
                    type="number"
                    className="form-control"
                    id="first-percent"
                    required
                  />
                </div>

                <div className="d-flex align-items-center py-2">
                  <label className="pl-2">نوع همکاری : </label>
                  <span className="px-2">
                    <span className="pl-2">
                      <input
                        className="hover"
                        type="radio"
                        name="type-collaboration"
                        defaultChecked="checked"
                        value={
                          typeCollaboration.typeCollaborationConstant
                            .WITHOUT_PERMANENT_PERCENT
                        }
                        onChange={() => {
                          setTypeCollaborationUser(
                            typeCollaboration.typeCollaborationConstant
                              .WITHOUT_PERMANENT_PERCENT
                          );
                        }}
                      />
                    </span>
                    <span>بدون درصد دائمی</span>
                  </span>
                  <span className="px-2">
                    <span className="pl-2">
                      <input
                        className="hover"
                        type="radio"
                        name="type-collaboration"
                        value={
                          typeCollaboration.typeCollaborationConstant
                            .WITH_LIMITED_PERMANENT_PERCENT
                        }
                        onChange={() => {
                          setTypeCollaborationUser(
                            typeCollaboration.typeCollaborationConstant
                              .WITH_LIMITED_PERMANENT_PERCENT
                          );
                        }}
                      />
                    </span>
                    <span>با درصد دائمی محدود</span>
                  </span>
                  <span className="px-2">
                    <span className="pl-2">
                      <input
                        className="hover"
                        type="radio"
                        name="type-collaboration"
                        value={
                          typeCollaboration.typeCollaborationConstant
                            .WITH_UNLIMITED_PERMANENT_PERCENT
                        }
                        onChange={() => {
                          setTypeCollaborationUser(
                            typeCollaboration.typeCollaborationConstant
                              .WITH_UNLIMITED_PERMANENT_PERCENT
                          );
                        }}
                      />
                    </span>
                    <span>با درصد دائمی نامحدود</span>
                  </span>
                </div>

                {typeCollaborationUser !=
                  typeCollaboration.typeCollaborationConstant
                    .WITHOUT_PERMANENT_PERCENT && (
                  <div className="d-flex align-items-center py-2">
                    <label className="pl-2">درصد دائمی</label>
                    <input
                      max="100"
                      min="1"
                      style={{ width: "80px" }}
                      type="number"
                      className="form-control"
                      id="permanent-percent"
                      value={permanentPercent}
                      onChange={(e) => {
                        setPermanentPercent(parseInt(e.target.value));
                      }}
                    />
                  </div>
                )}

                {typeCollaborationUser ==
                  typeCollaboration.typeCollaborationConstant
                    .WITH_LIMITED_PERMANENT_PERCENT && (
                  <div className="d-flex align-items-center py-2">
                    <label className="pl-2">تعداد درصد دائمی نامحدود </label>
                    <input
                      style={{ width: "100px" }}
                      min="1"
                      type="number"
                      className="form-control"
                      id="count-permanent-percent"
                      value={countPermanentPercent}
                      onChange={(e) => {
                        setCountPermanentPercent(parseInt(e.target.value));
                      }}
                    />
                  </div>
                )}

                <div className="py-2">
                  <button className="btn btn-success">اضافه کردن</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
